module.exports = "{{if filteredRecordCount !== undefined}}Filter matches {{:filteredRecordCount}} of {{/if}}{{:actualRecordCount}} records.";